import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const ExcluirResponsavel = () => {
    const { id } = useParams();    
    const { showNotification } = useNotification();
    const url = `guardian/${id}`;
    const navigate = useNavigate();

    const [name, setName] = useState('');

    useEffect(() => {
        fetch(url, {            
        })
        .then(response => response.json())
        .then(data => setName(data.name));
    }, [url]);

    const handleDelete = async (e) => {
        e.preventDefault();
        try {
            const response = await authFetch(url, {
                method: 'DELETE',                
            });

            if (!response.ok) throw new Error('Erro ao excluir responsável');

            showNotification('success', 'Responsável excluído com sucesso!');
            navigate('/');
        } catch (error) {
            console.error(error);
            showNotification('danger', error.message);
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <h4 className="font-weight-bolder mb-0">Excluir Responsável</h4>
                    </aside>
                    <div className="column-responsive column-80">
                        <form onSubmit={handleDelete}>
                            <fieldset className="col-md-6">
                                <p>Tem certeza que deseja excluir o responsável <strong>{name}</strong>?</p>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <button type="button" onClick={() => navigate('/')} className="btn btn-info btn-sm">Cancelar</button>
                                    <button type="submit" className="btn btn-danger btn-sm mx-1">Excluir</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcluirResponsavel;
